import * as React from "react";
const EditBrushIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.43328 7.98993L9.58148 11.1381M5.57902 16.1171C4.43998 17.2562 2.26664 16.9714 0.599976 16.9714C1.45423 15.3048 0.315201 13.1313 1.45423 11.9923C2.59326 10.8533 4.43998 10.8533 5.57902 11.9923C6.71804 13.1313 6.71804 14.9781 5.57902 16.1171ZM8.86798 11.9086L16.4822 3.68519C17.1529 2.96089 17.1312 1.83606 16.4332 1.13807C15.7353 0.44008 14.6105 0.418455 13.8861 1.0891L5.66276 8.70335C5.23781 9.09685 5.02533 9.2936 4.90142 9.50335C4.60426 10.0065 4.5923 10.6285 4.8699 11.1427C4.98567 11.3572 5.19042 11.5619 5.59993 11.9714C6.00944 12.3809 6.2142 12.5857 6.42863 12.7014C6.94281 12.979 7.56481 12.9671 8.06798 12.6699C8.27781 12.546 8.47448 12.3335 8.86798 11.9086Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditBrushIcon;
